import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { track, events } from 'src/configs/amplitude';
import PropTypes from 'prop-types';
import { Typography, TextField, Button, Grid, LinearProgress } from '@mui/material';
import { useFormik } from 'formik';
import { resetPasswordInitialValues, resetPasswordSchema } from 'src/utils/formValidation/ResetPassword';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { beforeSubmitDataValidation } from 'src/core/services/beforeSubmitDataValidation';
import SplitPageContainer from 'src/components/shared/SplitPageContainer';
import LoginLeftContent from 'src/components/shared/LoginLeftContent';
import forgotPassSvg from 'src/img/forgot-pass.svg';
import useStyles from './styles';
export const ResetPasswordPage = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const page = 'Reset Password';
  const formik = useFormik({
    initialValues: resetPasswordInitialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: async values => {
      const data = _objectSpread({}, values);
      const resp = await store.account.forgotAccountPasswordAsync.run(beforeSubmitDataValidation(data));
      if (resp && resp.isSuccessful) {
        navigate('/reset_request');
      }
    }
  });
  return /*#__PURE__*/React.createElement(SplitPageContainer, {
    largeTopMargin: true,
    imageScr: forgotPassSvg,
    leftBlock: /*#__PURE__*/React.createElement(LoginLeftContent, null)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('general.forgot_password')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('log_in_flow.reset_pass_instruction'))), /*#__PURE__*/React.createElement("form", {
    onSubmit: formik.handleSubmit,
    className: classes.mdSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('general.email_address'),
    variant: "outlined",
    fullWidth: true,
    id: "email",
    name: "email",
    value: formik.values.email,
    onBlur: e => {
      if (e.target.value) {
        formik.handleBlur(e);
        track(events.filled('Email'), {
          page
        });
      }
    },
    onChange: formik.handleChange,
    disabled: store.account.forgotAccountPasswordAsync.inProgress,
    error: formik.touched.email && !!formik.errors.email,
    helperText: formik.touched.email && t(formik.errors.email)
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, store.account.forgotAccountPasswordAsync.inProgress ? /*#__PURE__*/React.createElement("div", {
    className: classes.progressWrapper
  }, /*#__PURE__*/React.createElement(LinearProgress, null)) : /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "priority",
    fullWidth: true,
    disabled: !formik.isValid || !Object.keys(formik.touched).length,
    onClick: () => track(events.clicked('Request Password Reset'), {
      page
    }),
    'custom-attribute': '798-reset-password-page'
  }, t('buttons.request_reset'))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    variant: "text",
    to: "/login",
    fullWidth: true,
    disabled: store.account.forgotAccountPasswordAsync.inProgress,
    onClick: () => track(events.clicked('Back To Login'), {
      page
    }),
    'custom-attribute': '799-reset-password-page'
  }, t('buttons.back_to_login'))))));
});
ResetPasswordPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};